import { TripType } from '@honeycomb/data';
export var FunnelStep;
(function (FunnelStep) {
    FunnelStep[FunnelStep["ChooseHotel"] = 0] = "ChooseHotel";
    FunnelStep[FunnelStep["ChooseRoom"] = 1] = "ChooseRoom";
    FunnelStep[FunnelStep["ConfirmFlight"] = 2] = "ConfirmFlight";
    FunnelStep[FunnelStep["CustomiseTrip"] = 3] = "CustomiseTrip";
    FunnelStep[FunnelStep["CustomiseTripHotel"] = 4] = "CustomiseTripHotel";
    FunnelStep[FunnelStep["CustomiseTripFlight"] = 5] = "CustomiseTripFlight";
    FunnelStep[FunnelStep["TransferSearch"] = 6] = "TransferSearch";
    FunnelStep[FunnelStep["ChooseTransfer"] = 7] = "ChooseTransfer";
    FunnelStep[FunnelStep["GuestInformation"] = 8] = "GuestInformation";
    FunnelStep[FunnelStep["PaymentDetails"] = 9] = "PaymentDetails";
    FunnelStep[FunnelStep["Book"] = 10] = "Book";
})(FunnelStep || (FunnelStep = {}));
export const getHolidayFunnelStepperRoute = ({ funnelStep, tripType, queryString, estabId, hasMandatoryTransfer, }) => {
    switch (funnelStep) {
        case FunnelStep.ChooseHotel:
            return tripType === TripType.Holiday ? `/holidays/hotels/${queryString}` : `/hotels/${queryString}`;
        case FunnelStep.ChooseRoom:
            return tripType === TripType.Holiday
                ? `/holidays/hotels/${estabId}${queryString}`
                : `/hotels/${estabId}${queryString}`;
        case FunnelStep.ConfirmFlight:
            return `/holidays/flights${queryString}`;
        case FunnelStep.CustomiseTrip:
            return `/holidays/flights/options${queryString}`;
        case FunnelStep.CustomiseTripHotel:
            return hasMandatoryTransfer ? `/hotels/options/${queryString}` : `/hotels/extras/${queryString}`;
        default:
            return null;
    }
};
